
import { SimplePagination } from "@/components/ui/shared/SimplePagination";

interface PaginationProps {
  page: number;
  totalPages: number;
  loading: boolean;
  onPageChange: (page: number) => void;
}

export const Pagination = (props: PaginationProps) => {
  return <SimplePagination {...props} />;
};
